const STORAGE_KEY = 'jangi.oauthSignup'

export type OAuthSignupDraft = {
  ticket: string
  provider: 'kakao'
  email: string
  name: string
  emailVerified: boolean
}

export function saveOAuthSignup(draft: OAuthSignupDraft) {
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(draft))
}

export function readOAuthSignup(): OAuthSignupDraft | null {
  const raw = sessionStorage.getItem(STORAGE_KEY)
  if (!raw) {
    return null
  }

  try {
    const parsed = JSON.parse(raw) as OAuthSignupDraft
    if (!parsed.ticket || parsed.provider !== 'kakao') {
      return null
    }
    return parsed
  } catch {
    return null
  }
}

export function clearOAuthSignup() {
  sessionStorage.removeItem(STORAGE_KEY)
}
